import { Component } from '@angular/core';
import { ConstantsService } from '@app/services/constants.service';
import { UserService } from '@app/services/user.service';
import SwiperCore, { Autoplay, Navigation, Pagination, SwiperOptions } from 'swiper';

SwiperCore.use([Navigation, Pagination, Autoplay])

@Component({
  selector: 'swiper-home-header',
  templateUrl: './swiper-home-header.component.html',
  styleUrls: ['./swiper-home-header.component.css']
})
export class SwiperHomeHeaderComponent {

  public swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 450,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    loop: false,
    grabCursor: true,
    pagination: {
      el: '#swiper-pagination-home-header',
      clickable: true,
    },
    navigation: {
      nextEl: '#swiper-pagination-home-header-next',
      prevEl: '#swiper-pagination-home-header-prev',
    }
  }



  constructor(public constantsService: ConstantsService, public userService: UserService
  ) { }
}
